import { ReactFlowProvider } from '@xyflow/react';
import LayoutFlow from './LayoutFlow';
import React, { useRef, useState, useEffect } from 'react';

interface LayoutFlowContainerProps {
  graphID: string;
  isMobileSidebar?: boolean;
}

const LayoutFlowContainer = ({ graphID, isMobileSidebar = false }: LayoutFlowContainerProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return (
    <div ref={containerRef} className="w-full h-full">
      <LayoutFlow graphID={graphID} containerWidth={containerWidth} />
    </div>
  );
};

export default LayoutFlowContainer;
